module.exports = __webpack_public_path__ + "assets/img/rule_4.eedfd2c7.png";